import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { FeatureFlags } from 'UI/constants/featureFlags';

export const useContactProfileFeatureFlags = () => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();

  return {
    canRequestDoNotContact: checkIfFeatureFlagEnabled(FeatureFlags.RequestDoNotContactFromProfile),
    canRequestDoNotEngage: checkIfFeatureFlagEnabled(FeatureFlags.RequestDoNotEngageFromProfile),
    isAddDailyPlanTaskEnabled: checkIfFeatureFlagEnabled(FeatureFlags.DailyPlanAddTaskFromProfile),
    isEnabledAddAsACandidate: checkIfFeatureFlagEnabled(FeatureFlags.NewCandidateFromContact)
  };
};
